import './index.css'


const Index = ({dataUsers, dataSorteos, socket})=>{
    
    return(
        <div className="Index">
            <div className="content-info">
                <table className="table-Info">
                    <tbody>
                        <tr>
                            <td>Usuarios Registrados</td>
                            <td>{dataUsers.length}</td>
                        </tr>
                        <tr>
                            <td>Sorteos Activos</td>
                            <td>{dataSorteos.length}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default Index